<template>
  <div @dragover="allowTemplateBind"
       @drop="(event) => dragToUDSCmp(event, itemData, componentIndex)"
       class="uds">
    <el-container style="width: 100%;height: 100%">
      <el-header style="height: 450px;padding: 0 10px 0 0">
        <el-container style="width: 100%;height: 100%">
          <el-aside style="padding: 0;width: 400px">
            <el-card class="box-card" style="height: 95%">
              <el-container style="width: 100%;height: 100%;">
                <el-header style="padding: 0;height: 100px;">
                  <el-row style="margin-top: 0">
                    <span class="title">诊断请求输入</span>
                  </el-row>
                  <el-tooltip :content="currentCommand.length===0?'暂无命令':currentCommand" class="item"
                              effect="dark"
                              placement="top">
                    <el-row style="margin-top: 10px">
                      <a>
                        <span style="font-size: 16px;line-height: 36px;width: 300px;overflow: hidden">当前命令：{{displayCommand}}</span>
                      </a>
                      <el-button @click="addCommand" size="medium" style="float: right;" type="primary">添加</el-button>
                    </el-row>
                  </el-tooltip>
                </el-header>
                <el-main style="width: 100%;padding: 0">
                  <el-container style="width: 100%;height: 325px">
                    <el-main style="padding: 0;overflow: hidden">
                      <a>
                        <el-input placeholder="UDS Command" style="width: 100%;float: left;margin-top: 20px"
                                  v-model="command"
                                  v-show="inputMode==='命令模式'">
                          <template slot="prepend">0x</template>
                          <i
                            class="el-icon-edit el-input__icon"
                            slot="suffix">
                          </i>
                        </el-input>
                        <el-input placeholder="Remarks for It" style="width: 100%;float: left;margin-top: 20px"
                                  v-model="remark"
                                  v-show="inputMode==='命令模式'">
                          <i
                            class="el-icon-paperclip el-input__icon"
                            slot="suffix">
                          </i>
                        </el-input>
                      </a>
                      <div class=service v-show="inputMode==='选择模式'">
                        <a>
                          <div class="select">
                            <el-row>
                              <span class="label">Service</span>
                              <el-tooltip :content="selectedServiceString.length===0?'未选择':selectedServiceString"
                                          class="item"
                                          effect="dark"
                                          placement="right">
                                <el-cascader
                                  :options="serviceOptions"
                                  filterable
                                  placeholder="请选择服务"
                                  v-model="selectedService">
                                </el-cascader>
                              </el-tooltip>
                            </el-row>
                            <div class=select v-show="didNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">DID</span>
                                <el-tooltip :content="selectedDID.length===0?'未选择':selectedDID" class="item"
                                            effect="dark" placement="right">
                                  <el-select filterable placeholder="请选择数据标识符" v-model="selectedDID">
                                    <el-option
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                      v-for="item in didOptions">
                                    </el-option>
                                  </el-select>
                                </el-tooltip>
                              </el-row>
                            </div>
                            <div class=select v-show="dtcNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">DTC</span>
                                <el-tooltip :content="selectedDTC.length===0?'未选择':selectedDTC" class="item"
                                            effect="dark" placement="right">
                                  <el-select filterable placeholder="请选择诊断故障码" v-model="selectedDTC">
                                    <el-option
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                      v-for="item in dtcOptions">
                                    </el-option>
                                  </el-select>
                                </el-tooltip>
                              </el-row>
                            </div>
                            <div class=select v-show="snapshotNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">Snapshot</span>
                                <el-tooltip :content="selectedSnapshot.length===0?'未选择':selectedSnapshot" class="item"
                                            effect="dark"
                                            placement="right">
                                  <el-select filterable placeholder="请选择快照记录" v-model="selectedSnapshot">
                                    <el-option
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                      v-for="item in snapshotOptions">
                                    </el-option>
                                  </el-select>
                                </el-tooltip>
                              </el-row>
                            </div>
                            <div class=select v-if="functionalGroupIdentifierNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">GroupId</span>
                                <el-input maxlength="2" placeholder="请输入功能群组标识符" v-model="functionalGroupIdentifier">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-if="dtcSeverityMaskNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">Severity</span>
                                <el-input maxlength="2" placeholder="请输入DTC严重度掩码" v-model="dtcSeverityMask">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-show="dtcStatusMaskNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">Status</span>
                                <el-input maxlength="2" placeholder="请输入DTC状态掩码" v-model="dtcStatusMask">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-if="dtcStoredDataRecordNumberNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">StoreData</span>
                                <el-input maxlength="2" placeholder="请输入存储数据记录号" v-model="dtcStoredDataRecordNumber">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-if="dtcExtDataRecordNumberNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">ExtData</span>
                                <el-input maxlength="2" placeholder="请输入扩展数据记录号" v-model="dtcExtDataRecordNumber">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-if="memorySelectionNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">Memory</span>
                                <el-input maxlength="2" placeholder="请输入内存选区" v-model="memorySelection">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                            <div class=select v-if="keyNeededService.indexOf(currentService)>-1">
                              <el-row>
                                <span class="label">Key</span>
                                <el-input placeholder="请输入安全密钥" v-model="securityKey">
                                  <template slot="prepend">0x</template>
                                </el-input>
                              </el-row>
                            </div>
                          </div>
                        </a>
                      </div>
                    </el-main>
                    <el-footer style="height: 60px;padding: 0">
                      <div style="float: left">
                        <el-tag
                          :key="item.key"
                          type="info"
                          v-for="item in templateInfo">
                          {{item.text}}
                        </el-tag>
                      </div>
                      <el-radio-group size="small" style="float: right;" v-model="inputMode">
                        <el-radio-button label="选择模式"></el-radio-button>
                        <el-radio-button label="命令模式"></el-radio-button>
                      </el-radio-group>
                    </el-footer>
                  </el-container>
                </el-main>
              </el-container>
            </el-card>
          </el-aside>
          <el-main style="padding: 0 0 0 10px">
            <el-card style="height: 95%;padding: 0">
              <span class="title">诊断请求列表</span>
              <div class="cmp-handle">
                <el-dropdown v-show="!showBatchButton">
                    <span class="el-dropdown-link">
                        <i class="el-input__icon el-icon-more" style="line-height: 20px;width: 20px"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item disabled v-if="templateInfo.length===0">未绑定解析模板</el-dropdown-item>
                    <el-dropdown-item :key="item.key" @click.native="handleCmp('unbindTemplate', item)"
                                      v-for="item in templateInfo">
                      {{item.text}} <i class="el-icon-close" style="color: red;font-weight: bold"></i>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="handleCmp('deleteUDS', componentIndex)"
                                      divided>删除组件
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <span class="table-ext-button">
                <el-button @click="saveAllCommand" icon="el-icon-takeaway-box" round size="small"
                           style="margin-right: 20px" type="primary" v-show="!showBatchButton">保存</el-button>
                <el-button :disabled="!getCurCmpStatus" @click="batchSendCommand" circle
                           icon="el-icon-s-promotion" size="mini" type="primary" v-show="showBatchButton"></el-button>
              <el-button @click="batchDeleteCommand" circle icon="el-icon-delete" size="mini"
                         type="danger" v-show="showBatchButton"></el-button>
              </span>
              <a>
                <el-table
                  :data="commandData" @selection-change="handleRequestSelectionChange"
                  class="table"
                  empty-text="暂无请求"
                  height="85%"
                  v-chat-scroll>
                  <el-table-column fixed type="expand">
                    <template slot-scope="props">
                      <el-form class="table-expand" inline label-position="left">
                        <el-form-item label="诊断指令">
                          <span>{{ props.row.command }}</span>
                        </el-form-item>
                        <el-form-item label="添加时间">
                          <span>{{ props.row.time }}</span>
                        </el-form-item>
                        <el-form-item label="请求内容">
                          <span>{{ props.row.content }}</span>
                        </el-form-item>
                        <el-form-item label="状态">
                      <span v-if="props.row.status === 0">
                未发送
              </span>
                          <span v-if="props.row.status === 1">
                发送成功
              </span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    fixed
                    label="诊断指令"
                    min-width="100"
                    prop="command"
                    sortable>
                  </el-table-column>
                  <!--                  <el-table-column-->
                  <!--                    label="添加时间"-->
                  <!--                    prop="time"-->
                  <!--                    sortable-->
                  <!--                    width="180">-->
                  <!--                  </el-table-column>-->
                  <el-table-column
                    label="请求内容"
                    min-width="200"
                    prop="content">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    prop="status"
                    sortable
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status === 0">
                未发送
              </span>
                      <span v-if="scope.row.status === 1">
                发送成功
              </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="200">
                    <template slot-scope="scope">
                      <el-button :disabled="!getCurCmpStatus" @click="sendCommand(scope.row.command,scope.row.time)"
                                 class="buttons" round size="small"
                                 type="primary" v-if="scope.row.status===0">
                        发送指令
                      </el-button>
                      <el-button :disabled="!getCurCmpStatus" @click="sendCommand(scope.row.command,scope.row.time)"
                                 class="buttons" round size="small"
                                 type="primary" v-else>
                        重新发送
                      </el-button>
                      <el-button @click.native.prevent="deleteRow(scope.row.command,scope.row.time,commandData)"
                                 class="buttons" icon="el-icon-delete" round size="small"
                                 type="danger">删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </a>
            </el-card>
          </el-main>
        </el-container>
      </el-header>
      <el-main style="padding: 0 10px 0 0">
        <el-card class="box-card" style="height: 95%">
          <span class="title" style="margin-bottom: 20px">诊断响应列表</span>
          <span class="table-ext-button">
            <el-popover
              placement="right"
              trigger="click"
              width="400">
                <el-container style="height:600px;width: 100%">
                  <el-main>
                <el-timeline :key="item.data" v-for="item in frameList">
                  <el-timeline-item :color="getFrameStyle(item.id).color" :icon="getFrameStyle(item.id).icon"
                                    :timestamp='getTimeStamp(item.time)' placement="top">
                    <el-card :body-style="{ padding: '0px' }">
                      <p :style="getFrameStyle(item.id).style">{{formatCommand(item.data)}}</p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
                  </el-main>
                </el-container>
              <el-button plain slot="reference" type="primary" v-show="showInteractionButton">
                <i class="el-icon-chat-dot-square" style="margin-right: 5px"></i>交互详情
              </el-button>
            </el-popover>
            <el-button @click="deleteSelectedResponse" icon="el-icon-delete" plain
                       type="danger" v-show="showDeleteResponseButton">删除结果</el-button>
          </span>
          <a>
            <el-table
              :data="responseData"
              :span-method="objectSpanMethod"
              @selection-change="handleResponseSelectionChange"
              border
              height="85%"
              class="table"
              empty-text="暂无响应"
              stripe
            >
              <el-table-column
                align="center"
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                align="center"
                label="诊断指令"
                min-width="100"
                prop="request">
              </el-table-column>
              <el-table-column
                align="center"
                label="响应时间"
                prop="time"
                width="180">
              </el-table-column>
              <el-table-column
                align="center"
                label="响应状态"
                prop="status"
                width="150">
              </el-table-column>
              <el-table-column
                header-align="center"
                label="参数名"
                min-width="150"
                prop="parameter">
              </el-table-column>
              <el-table-column
                header-align="center"
                label="参数值"
                min-width="150"
                prop="value">
              </el-table-column>
            </el-table>
          </a>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'UDS',
  data() {
    return {
      inputMode: '选择模式',
      // 模板的基本信息
      templateInfo: [],
      // 模板包含的数据
      templateData: {},
      serviceOptions: [],
      didOptions: [],
      dtcOptions: [],
      snapshotOptions: [],

      //  进行选择的变量
      selectedService: [],
      selectedServiceString: '',
      selectedDID: '',
      selectedDTC: '',
      selectedSnapshot: '',

      // 手动输入的变量
      functionalGroupIdentifier: '',
      dtcStatusMask: '',
      dtcSeverityMask: '',
      dtcStoredDataRecordNumber: '',
      dtcExtDataRecordNumber: '',
      memorySelection: '',
      securityKey: '',

      // 变量匹配的服务列表
      didNeededService: ['22', '24', '2A'],
      dtcNeededService: ['19 03', '19 04', '19 06', '19 09', '19 10', '19 18', '19 19'],
      snapshotNeededService: ['19 03', '19 04', '19 18'],
      functionalGroupIdentifierNeededService: ['19 42', '19 55'],
      dtcStatusMaskNeededService: ['19 01', '19 02', '19 0F', '19 11', '19 12', '19 13', '19 17', '19 07', '19 08', '19 42'],
      dtcSeverityMaskNeededService: ['19 07', '19 08', '19 42'],
      dtcStoredDataRecordNumberNeededService: ['19 05'],
      dtcExtDataRecordNumberNeededService: ['19 06', '19 10', '19 16', '19 19'],
      memorySelectionNeededService: ['19 17', '19 18', '19 19'],
      keyNeededService: ['27 02'],

      command: '',
      remark: '',
      commandData: [],
      requestSelection: [],
      responseSelection: [],
      // 显示请求面板的批量按钮
      showBatchButton: false,
      // 响应数据
      responseData: [],
      // 显示删除响应结果的按钮
      showDeleteResponseButton: false,
      // 显示报文交互的按钮
      showInteractionButton: false,
      // 单个响应的报文交互信息
      rawData: '',
      frameList: [],
      reqId: '',
      respId: '',
    };
  },
  mounted() {
    this.getCommandData();
  },
  props: {
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
    // 当前组件的index
    componentIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState('Engineering', ['dragTreeNodeType', 'dragTreeNodeKey']),
    ...mapGetters('Engineering', ['getCurCmpStatus', 'getUdsResponse', 'getPanelId', 'getUdsTracker']),
    dataSource() {
      return this.itemData.dataSources || [];
    },
    currentService() {
      if (this.inputMode === '选择模式') {
        if (this.selectedService.length > 0) {
          let service = '';
          this.selectedService.map((item) => {
            const singlePart = this.getMatchedPart(item, '0x');
            service += singlePart;
          });
          // 去除多余空格，每两位之间插入空格，最后去除尾部空格
          return this.formatCommand(service);
        }
      }
      return '';
    },
    currentCommand() {
      if (this.inputMode === '命令模式') {
        // 去除多余空格，每两位之间插入空格，最后去除尾部空格
        return this.formatCommand(this.command);
      }
      const rawCommand = this.currentService
                    + this.getMatchedPart(this.selectedDID, '0x')
                    + this.getMatchedPart(this.selectedDTC, '0x')
                    + this.getMatchedPart(this.selectedSnapshot, '00')
                    + this.functionalGroupIdentifier
                    + this.dtcStatusMask
                    + this.dtcSeverityMask
                    + this.dtcStoredDataRecordNumber
                    + this.dtcExtDataRecordNumber
                    + this.memorySelection
                    + this.securityKey;
      return this.formatCommand(rawCommand);
    },
    displayCommand() {
      if (this.currentCommand.length < 20) {
        return this.currentCommand;
      }
      return `${this.currentCommand.substring(0, 20)}...`;
    },
    currentContent() {
      if (this.inputMode === '命令模式') {
        if (this.remark === '') {
          return 'Added By Command Mode';
        }
        return this.remark;
      }
      let content = this.selectedServiceString.replace(/( - 0x.{2})/g, '');
      if (this.selectedDID.length > 0) {
        content = `${content}| ${this.selectedDID}`.replace(/( - 0x.{4})/g, '');
      }
      if (this.selectedDTC.length > 0) {
        content = `${content}| ${this.selectedDTC}`.replace(/( - 0x.{6})/g, '');
      }
      return content;
    },
    rowSpan() {
      const spanArr = [];
      let position = 0;
      this.responseData.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1);
        } else if ((this.responseData[index].request === this.responseData[index - 1].request)
                        && (this.responseData[index].time === this.responseData[index - 1].time)) {
          spanArr[position] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          position = index;
        }
      });
      return spanArr;
    },
    udsResponse() {
      const tracker = this.getUdsTracker;
      if (this.getUdsResponse !== undefined) {
        return this.getUdsResponse.get(this.getPanelId);
      }
      return [];
    },
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', [
      'addTemplateToUDS', 'deleteUdsResponse']),
    dragToUDSCmp(event, item, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addTemplateToUDS({ dragNode, componentIndex });
      this.$message.success(`诊断服务组件成功绑定 ${dragNode.text}`);
    },
    allowTemplateBind(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.UDS_INFO) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleCmp(command, data) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'deleteUDS':
          this.$confirm('确定删除诊断服务组件?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 确认删除
              this.deleteCpt({ index: data });
            }).then(() => {
              this.$message({
                message: '删除成功！',
              });
            })
            .catch((err) => {
            });
          break;
        case 'unbindTemplate':
          this.$confirm(`确定解除与 ${data.text} 的绑定?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 确认解绑
              const { componentIndex } = this;
              this.$store.commit('Engineering/deleteDataSource', {
                cptIndex: componentIndex,
                dataSourceKey: data.key,
              });
              // 清空现有请求列表
              this.commandData = [];
            }).then(() => {
              this.$message({
                message: `与 ${data.text} 的绑定解除成功！`,
              });
            })
            .catch((err) => {
            });
          break;
        default:
          break;
      }
    },
    getTemplateData() {
      if (this.templateInfo.length > 0) {
        const { canConfigId } = this.templateInfo[0];
        projectDetailAPI.getUdsTemplateData(canConfigId)
          .then((res) => {
            this.templateData = res;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(`UDS模板数据获取失败 (${err[0]})：${err[1]}`);
          });
      } else {
        this.templateData = {};
      }
    },
    setServiceOptions() {
      const self = this;
      self.selectedService = [];
      if (self.templateData.serviceList === undefined) {
        self.serviceOptions = [];
        return;
      }
      const options = [];
      self.templateData.serviceList.map((serviceItem) => {
        const subFuntions = [];
        const { subFunctionMap } = self.templateData;
        if (subFunctionMap[serviceItem] !== undefined) {
          subFunctionMap[serviceItem].map((subFuntionItem) => {
            const singleSubfunction = { value: subFuntionItem, label: subFuntionItem };
            subFuntions.push(singleSubfunction);
          });
        }
        let singleService = {};
        if (subFuntions.length > 0) {
          singleService = { value: serviceItem, label: serviceItem, children: subFuntions };
        } else {
          singleService = { value: serviceItem, label: serviceItem };
        }

        options.push(singleService);
      });
      self.serviceOptions = options;
    },
    setDIDOptions() {
      const self = this;
      self.selectedDID = '';
      if (self.templateData.didList === undefined) {
        self.didOptions = [];
        return;
      }
      const options = [];
      self.templateData.didList.map((didItem) => {
        const singleDID = { value: didItem, label: didItem };
        options.push(singleDID);
      });
      self.didOptions = options;
    },
    setDTCOptions() {
      const self = this;
      self.selectedDTC = '';
      if (self.templateData.dtcList === undefined) {
        self.dtcOptions = [];
        return;
      }
      const options = [];
      self.templateData.dtcList.map((dtcItem) => {
        const singleDTC = { value: dtcItem, label: dtcItem };
        options.push(singleDTC);
      });
      self.dtcOptions = options;
    },
    setSnapshotOptions() {
      const self = this;
      self.selectedSnapshot = '';
      if (self.selectedDTC.length === 0) {
        self.snapshotOptions = [];
        return;
      }
      const dtc = this.getMatchedPart(self.selectedDTC, '0x');
      if (dtc === '') {
        self.snapshotOptions = [];
      } else {
        const options = [];
        if (self.templateData.dtcSnapshotRecord[dtc] !== undefined) {
          const specialSnapshot = { value: 'AllSnapshot 00FF', label: 'AllSnapshot 00FF' };
          options.push(specialSnapshot);
          self.templateData.dtcSnapshotRecord[dtc].map((snapshotItem) => {
            const singleSnapshot = { value: snapshotItem, label: snapshotItem };
            options.push(singleSnapshot);
          });
        }
        self.snapshotOptions = options;
      }
    },
    // 根据前缀找到唯一匹配的十六进制数，用于从完整参数描述中获取所需信息
    getMatchedPart(string, prefix) {
      const patternSrting = `${prefix}(.*)`;
      const pattern = new RegExp(patternSrting);
      if (pattern.test(string) === true) {
        return pattern.exec(string)[1];
      }
      return '';
    },
    // 判断字符串是否有效
    isValid(string) {
      if (string === undefined || string === null || string.length === 0) {
        return false;
      }
      return true;
    },
    // 将诊断命令格式化为相邻字节空格隔开的标准格式
    formatCommand(rawCommand) {
      if (this.isValid(rawCommand)) {
        return rawCommand.replace(/\s*/g, '').replace(/(.{2})/g, '$1 ').replace(/\s*$/g, '').toUpperCase();
      }
      return '';
    },
    // 获取当前时间并格式化
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hh = now.getHours();
      const mm = now.getMinutes();
      const ss = now.getSeconds();
      let clock = `${year}-`;
      if (month < 10) {
        clock += '0';
      }
      clock += `${month}-`;
      if (day < 10) {
        clock += '0';
      }
      clock += `${day} `;
      if (hh < 10) {
        clock += '0';
      }
      clock += `${hh}:`;
      if (mm < 10) clock += '0';
      clock += `${mm}:`;
      if (ss < 10) clock += '0';
      clock += `${ss}`;
      return (clock);
    },
    addCommand() {
      if (this.currentCommand.length > 0) {
        let flag = true;
        this.commandData.map((item) => {
          if (item.command == this.currentCommand) {
            this.$message.info('命令已存在，无需重复添加');
            flag = false;
          }
        });
        if (flag) {
          this.commandData.push({
            command: this.currentCommand,
            content: this.currentContent,
            time: this.getCurrentTime(),
            status: 0,
          });
          this.command = '';
          this.remark = '';
          this.$message.success('添加成功');
        }
      } else {
        this.$message.info('无法添加空命令');
      }
    },
    deleteRow(command, time, rows) {
      let index = 0;
      rows.map((item) => {
        if (item.command === command && item.time === time) {
          rows.splice(index, 1);
        }
        index += 1;
      });
    },
    // 批量删除命令
    batchDeleteCommand() {
      this.requestSelection.map((item) => {
        this.deleteRow(item.command, item.time, this.commandData);
      });
    },

    // 批量发送命令
    batchSendCommand() {
      this.requestSelection.map((item) => {
        this.sendCommand(item.command, item.time);
      });
    },
    async sendCommand(formattedCommand, time) {
      // 清除所有空格，得到待发送的命令
      const command = formattedCommand.replace(/\s*/g, '');
      console.log(command);
      const { canConfigId } = this.templateInfo[0];
      await projectDetailAPI.sendUDSCommand(canConfigId, command)
        .then((res) => {
          this.$message.success('发送成功');
          this.commandData.map((item) => {
            if (item.command === formattedCommand && item.time === time) {
              item.status = 1;
            }
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: `发送失败(${err[0]})：${err[1]}`,
          });
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 4) {
        const rowNum = this.rowSpan[rowIndex];
        const colNum = rowNum > 0 ? 1 : 0;
        return {
          rowspan: rowNum,
          colspan: colNum,
        };
      }
    },
    handleRequestSelectionChange(val) {
      this.requestSelection = val;
      if (val.length > 0) {
        this.showBatchButton = true;
      } else {
        this.showBatchButton = false;
      }
    },
    handleResponseSelectionChange(val) {
      this.responseSelection = val;
      console.log(val);
      if (val.length === 1) {
        this.showInteractionButton = true;
        const udsResponse = this.getUdsResponse.get(this.getPanelId);
        if (udsResponse !== undefined && udsResponse.length > 0) {
          udsResponse.map((item) => {
            console.log(item);
            if (item.time === val[0].time && this.formatCommand(item.request) === val[0].request) {
              this.frameList = item.frameList;
              const firstTime = this.frameList[0].time;
              this.frameList.map((frameItem) => {
                frameItem.time -= firstTime;
              });
              this.rawData = this.formatCommand(item.rawData);
            }
          });
        }
      } else {
        this.showInteractionButton = false;
      }
      if (val.length > 0) {
        this.showDeleteResponseButton = true;
      } else {
        this.showDeleteResponseButton = false;
      }
    },
    deleteSelectedResponse() {
      this.responseSelection.map((item) => {
        const { time } = item;
        const request = item.request.replace(/\s*/g, '');
        const panelId = this.getPanelId;
        this.deleteUdsResponse({ request, time, panelId });
      });
    },
    getFrameStyle(id) {
      if (this.reqId === '') {
        this.reqId = id;
      } else if (id !== this.reqId && this.respId === '') {
        this.respId = id;
      }
      let style;
      let icon;
      let color;
      if (id === this.reqId) {
        style = 'float:left;padding:10px';
        icon = 'el-icon-top-right';
        color = '#67C23A';
      } else {
        style = 'float:right;padding:10px';
        icon = 'el-icon-bottom-right';
        color = '#F56C6C';
      }
      return {
        style,
        icon,
        color,
      };
    },
    getTimeStamp(time) {
      if (time === 0) {
        return 'Start';
      }
      return `${time} ms`;
    },
    saveAllCommand() {
      const id = this.getPanelId;
      projectDetailAPI.saveUdsCommand(id, this.commandData)
        .then((res) => {
          this.$message.success('命令列表保存成功');
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: `命令列表保存失败(${err[0]})：${err[1]}`,
          });
        });
    },
    getCommandData() {
      const id = this.getPanelId;
      projectDetailAPI.getUdsCommand(id)
        .then((res) => {
          this.commandData = res;
        }).catch((err) => {
        });
    },
  },
  watch: {
    dataSource: {
      handler(newDataSource) {
        const self = this;
        self.templateInfo = newDataSource.map((item) => {
          const pattern = /(.*)_(\d{18})_(\d{18})/;
          if (pattern.test(item.key) === false) {
            console.debug('UDS模板key格式有误');
          }
          const arr = pattern.exec(item.key);
          return {
            key: item.key,
            text: arr[1],
            deviceId: arr[2],
            canConfigId: arr[3],
          };
        });
        this.getTemplateData();
      },
      deep: true,
      immediate: true,
    },
    templateData() {
      this.setServiceOptions();
      this.setDIDOptions();
      this.setDTCOptions();
    },
    selectedDTC() {
      this.setSnapshotOptions();
    },
    selectedService: {
      handler(newSelection) {
        this.selectedDTC = '';
        this.selectedDID = '';
        this.selectedSnapshot = '';
        this.functionalGroupIdentifier = '';
        this.dtcStatusMask = '';
        this.dtcSeverityMask = '';
        this.dtcStoredDataRecordNumber = '';
        this.dtcExtDataRecordNumber = '';
        this.memorySelection = '';
        this.securityKey = '';
        if (newSelection.length > 0) {
          let serviceString = '';
          newSelection.map((item) => {
            serviceString += ` ${item}  |`;
          });
          // 去除尾部的|
          this.selectedServiceString = serviceString.replace(/(^\|*)|(\|$)/g, '');
        }
      },
      deep: true,
      immediate: true,
    },
    udsResponse: {
      handler(newResponse) {
        const formattedResponse = [];
        if (newResponse !== undefined && newResponse.length > 0) {
          newResponse.map((item) => {
            if (item.result !== null) {
              item.result.map((resultItem) => {
                const singleResponse = {};
                singleResponse.request = this.formatCommand(item.request);
                singleResponse.time = item.time;
                singleResponse.status = item.status;
                singleResponse.parameter = resultItem[0];
                singleResponse.value = resultItem[1];
                formattedResponse.unshift(singleResponse);
              });
            } else {
              const singleResponse = {};
              singleResponse.request = this.formatCommand(item.request);
              singleResponse.time = item.time;
              singleResponse.status = item.status;
              singleResponse.parameter = '';
              singleResponse.value = '';
              formattedResponse.unshift(singleResponse);
            }
          });
        }
        this.responseData = formattedResponse;
      },
      immediate: true,
    },
    getPanelId() {
      this.getCommandData();
    },
  }
  ,
}
;
</script>

<style lang="scss">
  @import "../../style/mixin.scss";

  .uds {
    width: 100%;
    height: 100%;
    @include focus-scroll-bar;

    .title {
      float: left;
      font-size: 18px;
      margin-top: 20px;
      font-weight: bold;
    }

    .el-card__body {
      padding: 0 20px;
      height: 100%;
    }

    .service {
      .label {
        font-size: 15px;
        width: 50px;
        line-height: 40px;
      }

      .el-cascader, .el-select, .el-input {
        width: 280px;
        float: right;
      }

      .el-cascader__label {
        padding-right: 20px;
      }
    }

    .table {
      width: 100%;
      height: 85%;
      overflow: auto;
      @include focus-scroll-bar;

      .table-expand {
        font-size: 14px;

        label {
          width: 90px;
          color: #99a9bf;
        }

        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          width: 100%;
          height: 100%;
        }
      }

    }

    // 去除多余的横线
    .el-table::before {
      height: 0;
    }

    .cmp-handle {
      height: 40px;
      margin-top: 20px;
      float: right;
    }

    .table-ext-button {
      float: right;
      margin-top: 15px;
    }

    a {
      color: #000;

      &:hover {
        color: #000;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/engineering/UDS.vue